import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as HomeIcon } from '../../../assets/home-icon.svg';
import { ReactComponent as ItineraryIcon} from '../../../assets/Itinerary-icon.svg';
import { ReactComponent as NewTripIcon } from '../../../assets/new-trip.svg';
import { ReactComponent as BudgetIcon } from '../../../assets/budget-icon.svg';
import './NewTripNav.css'; 
import { useSelector } from "react-redux";

const NewTripNav = () => {
    const location = useLocation();
    const currentTrip = useSelector(state => state.trips.currentTrip);

    const isNewTripPage = location.pathname === "/Trips";
    const isItineraryPage = location.pathname.startsWith("/planner");

    const isBudgetPage = location.pathname === "/budget";

    return (
        <nav className="new-trip-nav">
            <h1>Tripmate</h1>
            <ul>
            <li className="homenav-header">
                <Link to="/" className={location.pathname === "/"? "nav-link active" : "nav-link"}>
                <HomeIcon className = "homenav-icon"/>
                Home</Link>
                </li>  
                <li className="homenav-header">
                <Link to="/trips" 
                className = {isNewTripPage ? "nav-link active" : "nav-link"} >
                <NewTripIcon className = "homenav-icon"/>
                New Trip</Link>
                </li>

              {currentTrip && (
                <> 
            <li className="homenav-header">
                {currentTrip ? (
                <Link to={`/planner/${currentTrip.TRIP_ID}`} className={isItineraryPage ? "nav-link active" : "nav-link"}
                >
                <ItineraryIcon className = "homenav-icon"/>
                 Itinerary
                 </Link>
                ) : (
                <span className="nav-link disabled">
                <ItineraryIcon className = "homenav-icon"/>
                 Itinerary
                </span>
                )}
                </li> 


                <li className="homenav-header">
                {currentTrip ? (
                    <Link to={`"/budget/${currentTrip.TRIP_ID}`}
                    className={isBudgetPage ? "nav-link active" : "nav-link"}
                    >
                    <BudgetIcon className = "homenav-icon"/>
                    Budget</Link>
                ) : (
                    <span className="nav-link disabled">
                        <BudgetIcon className = "homenav-icon"/>
                        Budget
                    </span>  
                )}  
             </li>
             </>
              )}
          </ul>
                
        </nav>
    );
};

export default NewTripNav;